/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import {
    BrandingUiBundle,
    Configuration,
    ConfigurationParameters,
    MsoDefaultBrandingUiBundleApi,
    MsoDefaultBrandingUiBundleRequest,
} from 'client-code/branding-ui-bundle';

import { APPLICATION_FEATURE_AREA } from '../../config';
import { CommonHeaders } from '../CommonHeaders';
import { Constants } from '../constants';
import { DeviceModel } from '../device/DeviceModel';
import { IMsoDefaultBrandingUiBundleServiceRepository } from '../interfaces/IMsoDefaultBrandingUiBundleServiceRepository';
import { Log } from '../logging/Log';
import { UniqueIdentifier } from '../utils/UniqueIdentifier';

export class MsoDefaultBrandingUiBundleServiceRepositoryImpl
    implements IMsoDefaultBrandingUiBundleServiceRepository
{
    private commonHeaders;

    private msoDefaultBrandingApi;

    private static baseUrl: string;

    private static whiny: boolean;

    private static brandingUiResponse: BrandingUiBundle = {};

    private TAG: string = 'MsoDefaultBrandingUiBundleServiceRepositoryImpl';

    public constructor() {
        this.commonHeaders = new CommonHeaders(APPLICATION_FEATURE_AREA.STARTUP).headers;
        const configurationParameters: ConfigurationParameters = {
            basePath: MsoDefaultBrandingUiBundleServiceRepositoryImpl.baseUrl,
            baseOptions: {
                timeout: Constants.SERVICE_CONNECTION_TIMEOUT,
                headers: this.commonHeaders,
            },
        };
        const configuration = new Configuration(configurationParameters);
        this.msoDefaultBrandingApi = new MsoDefaultBrandingUiBundleApi(configuration);
    }

    public static initialize(baseUrl: string, whiny?: boolean) {
        MsoDefaultBrandingUiBundleServiceRepositoryImpl.baseUrl = baseUrl;
        MsoDefaultBrandingUiBundleServiceRepositoryImpl.whiny = !!whiny;
    }

    private async fetchBrandingUiInfo(): Promise<void> {
        try {
            const requestParameters: MsoDefaultBrandingUiBundleRequest = {
                msoName: DeviceModel.getTiVoSettings().getMsoName(),
                slsDomain: DeviceModel.getTiVoSettings().getSlsDomain(),
                applicationFeatureArea: this.commonHeaders.ApplicationFeatureArea,
                applicationName: DeviceModel.getTiVoSettings().getAppName(),
                applicationVersion: DeviceModel.getAppVersionName(),
                deviceType: DeviceModel.getTiVoSettings().getDeviceType(),
                productName: DeviceModel.getTiVoSettings().getAppName(),
                originRequestId: UniqueIdentifier.generateOriginRequestId(),
                whiny: MsoDefaultBrandingUiBundleServiceRepositoryImpl.whiny.toString(),
            };

            const apiResponse =
                await this.msoDefaultBrandingApi.msoDefaultBrandingUiBundle(requestParameters);
            MsoDefaultBrandingUiBundleServiceRepositoryImpl.brandingUiResponse = apiResponse.data;
        } catch (error) {
            Log.e(this.TAG, 'getBrandingUiInfo', error);
            throw error;
        }
    }

    public getBrandingUiInfoForKey(key: string): any {
        Log.d(this.TAG, `returning brandingUiInfo for ${key}`);
        if (MsoDefaultBrandingUiBundleServiceRepositoryImpl.brandingUiResponse[key])
            return MsoDefaultBrandingUiBundleServiceRepositoryImpl.brandingUiResponse[key];
        throw new Error(`BrandingAssetNotFoundError for '${key}'.`);
    }

    public async fetchMsoDefaultBrandingUiInfo(): Promise<void> {
        try {
            await this.fetchBrandingUiInfo();
        } catch (error) {
            Log.e(this.TAG, 'getMsoDefaultBrandingUiInfo', error);
            throw error;
        }
    }
}
